"use client";

import Link from "next/link";
import { Button } from "@/components/ui";
import { useAuth } from "@/components/contexts";

import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
} from "@/components/ui";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui";
import { Menu } from "lucide-react";

export default function HeaderComponent() {
  return (
    <header className="sticky top-0 z-50 flex items-center justify-between border-b border-gray-200 bg-white/80 px-6 py-3 backdrop-blur-sm md:px-12 md:py-6">
      <Link href="/">
        {/* <Image
          src="/images/nsm.png"
          width={80}
          height={24}
          alt="NSM Logo"
          priority
          className="h-auto w-[80px] cursor-pointer"
        /> */}
        <div className="text-hableon flex items-baseline gap-2 text-2xl font-bold">
          <span className="font-montserrat">Jely</span>
          <span className="text-hableon/80 text-xs font-medium">
            신입생 관리 플랫폼
          </span>
        </div>
      </Link>

      {/* 데스크톱 메뉴 */}
      <nav className="hidden md:block">
        <DesktopNavigation />
      </nav>

      <nav className="hidden items-center gap-2 md:flex">
        <ConsoleLoginButton />
        <Link href="https://forms.hableon.com/nsm/request" target="_blank">
          <Button className="border-hableon text-hableon hover:bg-hableon border bg-transparent hover:text-white">
            지금 시작하기
          </Button>
        </Link>
      </nav>

      {/* 모바일 메뉴 */}
      <nav className="md:hidden">
        <MobileNavigation />
      </nav>
    </header>
  );
}

/*********************************
 * Desktop Navigation (>= md)
 *********************************/
function DesktopNavigation() {
  return (
    <NavigationMenu>
      <NavigationMenuList className="gap-6">
        <SingleItem title="홈" href="/" />
        <SingleItem title="기능" href="/features" />
        <SingleItem title="요금" href="/pricing" />
        <SingleItem
          title="문의"
          href="https://forms.hableon.com/nsm/contact"
          newTab
        />
      </NavigationMenuList>
    </NavigationMenu>
  );
}

function MobileNavigation() {
  return (
    <Sheet>
      <SheetTrigger aria-label="모바일 메뉴 열기" className="p-2">
        <Menu className="h-6 w-6" />
      </SheetTrigger>
      <SheetContent side="left" className="w-64 p-0">
        <nav className="mt-6">
          <ul className="flex flex-col gap-1">
            <MobileNavItem title="홈" href="/" />
            <MobileNavItem title="기능" href="/features" />
            <MobileNavItem title="요금" href="/pricing" />
            <MobileNavItem
              title="문의"
              href="https://forms.hableon.com/nsm/contact"
              newTab
            />
            <ConsoleLoginButton mobile />
          </ul>
        </nav>
      </SheetContent>
    </Sheet>
  );
}

function SingleItem({
  title,
  href,
  newTab = false,
}: {
  title: string;
  href: string;
  newTab?: boolean;
}) {
  return (
    <NavigationMenuItem>
      <NavigationMenuLink
        href={href}
        className="cursor-pointer text-gray-700 hover:text-blue-600"
        target={newTab ? "_blank" : "_self"}
      >
        {title}
      </NavigationMenuLink>
    </NavigationMenuItem>
  );
}

function MobileNavItem({
  title,
  href,
  msg,
  newTab,
}: {
  title: string;
  href?: string;
  msg?: string;
  newTab?: boolean;
}) {
  if (href) {
    return (
      <li>
        <Link
          href={href}
          className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
          target={newTab ? "_blank" : "_self"}
        >
          {title}
        </Link>
      </li>
    );
  }
  return (
    <li>
      <Button variant="outline" className="w-full" onClick={() => alert(msg)}>
        {title}
      </Button>
    </li>
  );
}

function ConsoleLoginButton({ mobile = false }: { mobile?: boolean }) {
  const { isAuthenticated } = useAuth();

  const msg = isAuthenticated ? "CONSOLE" : "로그인";
  const href = isAuthenticated ? "/console" : "/login";

  return (
    <Link href={href} passHref>
      <Button
        className={
          mobile
            ? "mx-[10px]"
            : "text-hableon hover:text-hableon/40 bg-transparent hover:bg-transparent"
        }
        asChild
      >
        <span>{msg}</span>
      </Button>
    </Link>
  );
}
